import type { DemoSet } from '../types'
import { cascade3plSet } from './cascade-3pl'
import { invoiceAuditSet } from './invoice-audit'
import { magicScienceSet } from './magic-science'
import { republicServicesSet } from './republic-services'
import { skuMasterDataAuditorSet } from './sku-master-data-auditor'

/**
 * Registry of demo sets. To add a new prospect: build a folder under sets/,
 * export a DemoSet from its index, and add it to this array. The first set
 * in the array is the default when demo mode is enabled with no prior
 * selection.
 */
export const DEMO_SETS: readonly DemoSet[] = [
  republicServicesSet,
  magicScienceSet,
  cascade3plSet,
  invoiceAuditSet,
  skuMasterDataAuditorSet,
]

export const DEFAULT_DEMO_SET_ID = DEMO_SETS[0].id

export function findDemoSetById(id: string | null): DemoSet | null {
  if (id === null) {
    return null
  }
  return DEMO_SETS.find((set) => set.id === id) ?? null
}
